import React from 'react';

import SalesReport from '../../components/Analyzing/SalesReport';

function SalesReportView() {
  return (
    <SalesReport />
  );
}

export default SalesReportView;
